// Rótulos de exibição para valores que vêm do backend como nome de enum.
//
// 🚨 POR QUE EXISTE (07/09/2026): identificador C# não leva acento, então `ModalidadeVaga.Hibrido` e
// `TipoContratacao.Estagio` chegavam à tela escritos "Hibrido" e "Estagio". O front já corrigia isso —
// em CINCO lugares diferentes, cada um com o seu próprio `if (m === "Hibrido")`. Onde alguém esqueceu,
// o erro aparecia para o usuário: 438 vagas exibiam "Hibrido" e 147, "Estagio", inclusive nos filtros.
//
// Um `if` repetido em cinco arquivos não é uma correção, é cinco chances de esquecer a sexta. Por isso
// o rótulo passa a ter um lugar só. Ver [[eairh-proatividade-aplicar-em-todo-lugar]] na memória.
//
// ⚠️ Isto é APENAS exibição. O valor enviado ao backend (filtro, formulário) continua sendo o nome do
// enum — traduzir na origem quebraria a comparação do outro lado.
const ROTULOS = {
  Hibrido: "Híbrido",
  Estagio: "Estágio",
  Junior: "Júnior",
  Senior: "Sênior",
  NaoInformado: "Não informado",
};

/** Nome de enum → texto para a tela. Valor desconhecido volta como veio. */
export const rotulo = (v) => (v == null ? v : ROTULOS[v] ?? v);

/** O mesmo, para campo com vários valores separados por vírgula ("Remoto,Hibrido"). */
export const rotuloLista = (v) =>
  !v ? v : String(v).split(",").map((x) => rotulo(x.trim())).filter(Boolean).join(", ");
